import { Method } from 'axios';
import ApiRoutes from './ApiRoutes';
import config from '../../config';
import {
  IApiBlogEntry,
  IApiBox,
  IApiQuickLink,
  IApiSlide,
  IApiSocialMedia,
} from '../common/interfaces/api.interface';
import { TFApiResponse } from '../common/types/fapi.types';

const FAPI_BASEURL = config.fapi.baseurl;

export default class FApiRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> extends ApiRoutes<TFApiResponse<TResponse>, TRequestData, TRequestParams> {
  public static getBlogEntries = new FApiRoutes<IApiBlogEntry[]>(`/blogs`, `get`);
  public static getBoxes = new FApiRoutes<IApiBox[]>(`/boxes`, `get`);
  public static getQuickLinks = new FApiRoutes<IApiQuickLink[]>(`/quick-links`, `get`);
  public static getSlides = new FApiRoutes<IApiSlide[]>(`/slides`, `get`);
  public static getSocialMedias = new FApiRoutes<IApiSocialMedia[]>(`/social-medias`, `get`);

  constructor(url: string, method: Method, withCredentials = false) {
    super(url, method, withCredentials, FAPI_BASEURL);
  }
}
